export const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
